import { render, staticRenderFns } from "./ModalCadastroUsuario.vue?vue&type=template&id=19238f86"
import script from "./ModalCadastroUsuario.vue?vue&type=script&lang=js"
export * from "./ModalCadastroUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports